import {defineNuxtPlugin} from '#app';
import {RegisteredRepositories} from '../config/application.services';

export default defineNuxtPlugin((nuxtApp) => {
    const registredRepositories = RegisteredRepositories.all();
    Object.getOwnPropertySymbols(registredRepositories).forEach((repositoryKey) => {
        nuxtApp.vueApp.provide(repositoryKey, registredRepositories[repositoryKey]);
    });
});
